/**
 * @file CatalogCardFontLine.tsx
 * @description Строка «Шрифт и цвет карточек — в Каталоге →» у «Похожих
 * товаров» вместо группы «Цвет и шрифт» (у «Товаров» тот же смысл несёт
 * `ProductCardLine`) (phase19.16, партия SB120,
 * этап 3б; uiux-sb120-stage3 §2.3; SB121; TD-436): карточку товара
 * оформляет «Сайт → Каталог → Карточка товара», одна на весь сайт. Переход
 * — тем же выбором конструктора, что «Изменить карточку →»
 * (`ProductCardLine`): несохранённый блок спросит «Сохранить / Не
 * сохранять». Вне конструктора (тесты) — только текст.
 */

import { useContext } from "react";

import { BuilderContext } from "../../builder-context";
import { CATALOG_CARD_SELECTION } from "../../../../lib/site-builder/panels";

export const CATALOG_CARD_FONT_TEXT = "Шрифт и цвет карточек — в Каталоге";

export function CatalogCardFontLine() {
  const b = useContext(BuilderContext);
  if (!b) return <p className="type-caption text-on-surface-variant">{CATALOG_CARD_FONT_TEXT}.</p>;
  return (
    <button
      type="button"
      className="type-caption inline-flex min-h-12 items-center self-start font-medium text-primary hover:underline"
      onClick={() => void b.select(CATALOG_CARD_SELECTION)}
    >
      {CATALOG_CARD_FONT_TEXT} →
    </button>
  );
}
